export const SearchFacetsListCodes = {
  brands: 'brands',
  amenities: 'amenities',
  propertyType: 'property-types',
  activities: 'activities-on-site',
  hotelType: 'hotel-service-types',
  events: 'meetings-and-events',
  transportation: 'transportation-types',
  leisureRegion: 'leisure-region',
  city: 'cities',
  country: 'countries',
  state: 'states',
};

export const SearchFacetsList = {
  brands: 'BRANDS',
  amenities: 'AMENITIES',
  propertyType: 'PROPERTY_TYPES',
  activities: 'ACTIVITIES',
  hotelType: 'HOTEL_SERVICE_TYPES',
  events: 'MEETINGS_EVENTS',
  transportation: 'TRANSPORTATION_TYPES',
  leisureRegion: 'LEISURE_REGIONS',
  city: 'CITIES',
  country: 'COUNTRIES',
  state: 'STATES',
  points: 'POINTS',
  distance: 'DISTANCE',
  price: 'PRICE',
};
